/* eslint-disable camelcase */
import update from 'immutability-helper';
import { get as getId } from '../../localId/localId';
import { API_CREATE_WORK_ORDER_SUCCESS, API_LOAD_WORK_ORDER_LOADED } from '../workOrders.reducer';

export const SAVE_EQUIPMENT_TIMESHEET = 'SAVE_EQUIPMENT_TIMESHEET';
export const ADD_LOCAL_EQUIPMENT_TIMESHEET = 'ADD_LOCAL_EQUIPMENT_TIMESHEET';
export const REMOVE_LOCAL_EQUIPMENT_TIMESHEET = 'REMOVE_LOCAL_EQUIPMENT_TIMESHEET';
export const API_REMOVE_EQUIPMENT_TIMESHEET = 'API_REMOVE_EQUIPMENT_TIMESHEET';
export const API_CREATE_EQUIPMENT_TIMESHEET = 'API_CREATE_EQUIPMENT_TIMESHEET';
export const API_UPDATE_EQUIPMENT_TIMESHEET = 'API_UPDATE_EQUIPMENT_TIMESHEET';

const API_REMOVE_EQUIPMENT_TIMESHEET_FAILED = 'API_REMOVE_EQUIPMENT_TIMESHEET_FAILED';
const API_REMOVE_EQUIPMENT_TIMESHEET_SUCCESS = 'API_REMOVE_EQUIPMENT_TIMESHEET_SUCCESS';
const API_REMOVE_EQUIPMENT_TIMESHEET_LOADING = 'API_REMOVE_EQUIPMENT_TIMESHEET_LOADING';
const API_CREATE_EQUIPMENT_TIMESHEET_SUCCESS = 'API_CREATE_EQUIPMENT_TIMESHEET_SUCCESS';
const API_UPDATE_EQUIPMENT_TIMESHEET_SUCCESS = 'API_UPDATE_EQUIPMENT_TIMESHEET_SUCCESS';

const defaultState = { timesheets: {} };
const emptyTimesheet = workorder_id => ({ id: getId(), workorder_id, dirty: true });

// eslint-disable-next-line object-curly-newline
export const reducer = (state = defaultState, { type, response, resource, id, workOrderId, replaceId }) => {
  switch (type) {
    case SAVE_EQUIPMENT_TIMESHEET:
      return update(state, { timesheets: { [resource.id]: { $set: { ...emptyTimesheet(), ...resource } } } });
    case API_LOAD_WORK_ORDER_LOADED:
      return update(state, { timesheets: { $set: response.equipment_timesheets.reduce((obj, next) => Object.assign(obj, { [next.id]: next }), {}) } });
    case ADD_LOCAL_EQUIPMENT_TIMESHEET:
      const timesheet = emptyTimesheet(workOrderId);
      return update(state, { timesheets: { [timesheet.id]: { $set: timesheet } } });
    case API_REMOVE_EQUIPMENT_TIMESHEET_SUCCESS:
    case REMOVE_LOCAL_EQUIPMENT_TIMESHEET:
      return update(state, { timesheets: { $unset: [id] } });
    case API_REMOVE_EQUIPMENT_TIMESHEET_FAILED:
      return update(state, { timesheets: { [id]: { removing: { $set: false } } } });
    case API_REMOVE_EQUIPMENT_TIMESHEET_LOADING:
      return update(state, { timesheets: { [id]: { removing: { $set: true } } } });
    case API_CREATE_EQUIPMENT_TIMESHEET_SUCCESS:
      return update(state, { timesheets: { [response.id]: { $set: response }, $unset: [replaceId] } });
    case API_UPDATE_EQUIPMENT_TIMESHEET_SUCCESS:
      return update(state, { timesheets: { [response.id]: { $set: response } } });
    case API_CREATE_WORK_ORDER_SUCCESS:
      return Object.keys(state.timesheets).reduce((s, eId) => update(s, { timesheets: { [eId]: { workorder_id: { $set: response.id } } } }), state);
    default:
      return state;
  }
};

export const timesheets = (workOrderId, state) => Object.values(state.equipmentTimesheets.timesheets).filter(o => o.workorder_id.toString() === workOrderId.toString());
export const dirtyTimesheets = state => Object.values(state.equipmentTimesheets.timesheets).filter(o => o.dirty);
export const areDirtyTimesheets = state => dirtyTimesheets(state).length > 0;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/workOrder/equipmentTimesheets/equipmentTimesheets.reducer.js